<template>
    <q-page class="q-pa-md">

        <q-dialog v-model="dialogProvisional" persistent>
            <q-card>
                <q-bar>
                    <div>ID Provisionales no se encontraron</div>
                    <q-space />
                    <q-btn dense flat icon="close" v-close-popup>
                        <q-tooltip>Close</q-tooltip>
                    </q-btn>
                </q-bar>
                <q-card-section>
                    <q-btn color="primary" class="full-width" icon="mdi-file-excel" label="Exportar Excel"
                        @click="exportarExcel()" />

                    <q-table class="q-mt-md shadow-0" dense style="height: 100%;" :data="dataIDSProvisional"
                        :columns="columnsProvisional" row-key="id_provisional">
                        <template v-slot:loading>
                            <q-inner-loading showing color="primary" />
                        </template>
                        <template v-slot:body="props">
                            <q-tr :props="props">
                                <q-td key="id_provisional" :props="props">{{ props.row.id_provisional }}</q-td>
                            </q-tr>
                        </template>
                    </q-table>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-scroll-area class="q-pt-md" style="height: 100%; ">
            <q-card class="q-pa-md">
                <q-card-section>
                    <div class="row q-col-gutter-md">
                        <div class="col-12 q-mb-md">
                            <div class="text-h6 text-primary">Conciliación de Bienes</div>
                            <div class="text-subtitle2 text-grey"> Exporta un archivo Excel con el Número Nacional de
                                Inventario y el ID del Bien Nuevo para realizar la conciliación.
                            </div>
                        </div>
                        <div class="col-5">
                            <q-select dense bg-color="white" outlined v-model="item" option-label="nombre_unidad"
                                :options="data" label="Nombre de la Unidad" color="teal"
                                options-selected-class="text-deep-orange">
                                <template v-slot:option="scope">
                                    <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                        <q-item-section avatar>
                                            <q-icon name="mdi-hospital-building" />
                                        </q-item-section>
                                        <q-item-section>
                                            <q-item-label v-html="scope.opt.nombre_unidad" />
                                            <q-item-label caption>{{
                                                scope.opt.nombre_sede + ", " + scope.opt.nombre_tipo_unidad
                                                }}</q-item-label>
                                        </q-item-section>
                                    </q-item>
                                </template>
                            </q-select>
                        </div>
                        <div class="col-5">
                            <q-file outlined dense v-model="archivoExcel" label="Archivo Excel" accept=".xls,.xlsx"
                                @input="onFileAdded" />
                        </div>
                        <div class="col-2">
                            <q-btn color="primary" class="full-width" icon="mdi-vector-union" label="Conciliar"
                                @click="PostConciliacionExcel()" />
                        </div>
                    </div>
                </q-card-section>
                <q-separator />
                <q-card-section>
                    <q-table class="q-mt-md shadow-0" dense :loading="loading" style="height: 100%;" :filter="filter"
                        :data="dataIDS" :columns="columns" row-key="name">
                        <template v-slot:loading>
                            <q-inner-loading showing color="primary" />
                        </template>
                        <template v-slot:body="props">
                            <q-tr :props="props">
                                <q-td key="id_bienorigen" :props="props">{{ props.row.id_bienorigen }}</q-td>
                                <q-td key="id_provisional" :props="props">{{ props.row.id_provisional }}</q-td>
                            </q-tr>
                        </template>
                    </q-table>
                </q-card-section>
            </q-card>
        </q-scroll-area>
    </q-page>
</template>

<script>
import axios from 'axios'
import { date, QSpinnerFacebook } from 'quasar'
import { format } from 'date-fns';
import { exportFile } from "quasar";
import * as XLSX from "xlsx";
function wrapCsvValue(val, formatFn) {
    let formatted = formatFn !== void 0 ? formatFn(val) : val;

    formatted =
        formatted === void 0 || formatted === null ? "" : String(formatted);

    formatted = formatted.split('"').join('""');
    return `"${formatted}"`;
}
export default {
    components: {
    },
    data() {
        return {
            loading: false,
            data: [],

            columns: [
                { name: 'id_bienorigen', align: 'center', label: 'ID Activo', field: 'id_bienorigen', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'id_provisional', align: 'center', label: 'ID Activo Nuevo', field: 'id_provisional', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
            ],
            dataIDS: [],
            loading: false,
            filter: '',
            archivoExcel: null,
            item: {
                nombre_sede: "",
                nombre_tipo_unidad: "",
                nombre_unidad: "",
            },

            dataIDSProvisional: [],
            columnsProvisional: [
                { name: 'id_provisional', align: 'center', label: 'ID Activo Nuevo', field: 'id_provisional', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
            ],

            dialogProvisional: true
        }
    },
    computed: {
        usuarioStore() {
            return this.$store.state.usuario;
        },
    },
    created() {
        this.GetTablas();
    },
    methods: {

        async PostConciliacionExcel() {
            let objeto = {
                lista: this.dataIDS,
                _id_unidad: this.item._id_unidad,
                basedatos: this.item.bd_estado
            }
            console.log(objeto)
            this.$q.loading.show({ spinner: QSpinnerFacebook, spinnerColor: "white", spinnerSize: 140, message: "Conciliando bienes. Espere...", messageColor: "white", });
            try {
                let respuesa = await axios.post("AppMovil/PostConciliacionExcel/", objeto);
                console.log(respuesa);

                if (respuesa.data.edopet == '1') {
                    this.dialogProvisional = true
                    this.dataIDSProvisional = respuesa.data.lista
                }

                this.$q.notify({
                    type: 'positive',
                    message: `Se realizo la conciliacion.`
                });

                this.$q.loading.hide();
            } catch (error) {
                this.loading = false;
                console.log(error);
                this.$q.loading.hide();
            }
        },

        async GetTablas() {
            this.loading = true;
            try {
                let respuesa = await axios.get("Configuracion/GetTablas/" + this.usuarioStore.baseDatos);
                console.log(respuesa);
                this.loading = false;
                this.data = respuesa.data;
            } catch (error) {
                this.loading = false;
                console.log(error);
            }
        },

        onFileAdded(file) {
            // QFile devuelve directamente el archivo o array según el modo
            const selectedFile = Array.isArray(file) ? file[0] : file;
            console.log(selectedFile)
            if (!selectedFile) return;

            const reader = new FileReader();
            console.log(reader)


            reader.onload = (event) => {
                try {
                    const data = new Uint8Array(event.target.result);
                    const workbook = XLSX.read(data, { type: "array" });

                    // Tomar la primera hoja
                    const firstSheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[firstSheetName];

                    // Convertir a JSON
                    const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                    // Asumimos encabezado en la primera fila
                    const rows = jsonData.slice(1).map((row) => ({
                        id_bienorigen: row[0],
                        id_provisional: row[1],
                    }));

                    this.dataIDS = rows;
                } catch (err) {
                    console.error("Error al leer el Excel:", err);
                }
            };

            reader.readAsArrayBuffer(selectedFile);
        },
        exportarExcel() {
            // naive encoding to csv format
            const content = [
                this.columnsProvisional.map((col) => wrapCsvValue(col.label)),
            ]
                .concat(
                    this.dataIDSProvisional.map((row) =>
                        this.columnsProvisional
                            .map((col) =>
                                wrapCsvValue(
                                    typeof col.field === "function"
                                        ? col.field(row)
                                        : row[col.field === void 0 ? col.name : col.field],

                                    col.format
                                )
                            )
                            .join(",")
                    )
                )
                .join("\r\n");

            const status = exportFile(
                "ID_NoEncontrados.csv",
                content,
                "text/csv"
            );

            if (status !== true) {
                this.$q.notify({
                    message: "Browser denied file download...",
                    color: "negative",
                    icon: "warning",
                });
            }
        }
    }
}
</script>
<style lang="sass">
.my-sticky-header-table
  /* height or max-height is important */
  max-height: 500px

  .q-table__top,
  .q-table__bottom,
  thead tr:first-child th
    /* bg color is important for th; just specify one */
    background-color: #fff

  thead tr th
    position: sticky
    z-index: 1
  thead tr:first-child th
    top: 0

  /* this is when the loading indicator appears */
  &.q-table--loading thead tr:last-child th
    /* height of all previous header rows */
    top: 48px

  /* prevent scrolling behind sticky top row on focus */
  tbody
    /* height of all previous header rows */
    scroll-margin-top: 48px
</style>